module.exports = __webpack_public_path__ + "img/logo.37a9cd9.svg";